// StepUpDialog (Parte 14.2): reautenticação OIDC (`prompt=login&acr_values=urn:giyus:acr:mfa`). Esqueleto M0.
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@giyus/ui';
import { useTranslation } from 'react-i18next';

export interface StepUpDialogProps {
  readonly open: boolean;
  readonly onConfirm: () => void | Promise<void>;
  readonly onCancel: () => void;
}

export function StepUpDialog({ open, onConfirm, onCancel }: StepUpDialogProps) {
  const { t } = useTranslation('common');
  return (
    <Dialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          onCancel();
        }
      }}
    >
      <DialogContent closeLabel={t('a11y.closeDialog')}>
        <DialogHeader>
          <DialogTitle>{t('components.stepUp.title')}</DialogTitle>
          <DialogDescription>{t('components.stepUp.description')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onCancel}>
            {t('actions.cancel')}
          </Button>
          <Button
            onClick={() => {
              void onConfirm();
            }}
          >
            {t('components.stepUp.confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
